import { ServiceBase } from "./service-base";
import { NumericListOptions } from "../../models/interfaces/numeric-list-options";

interface ApiKeyResponse {
    id: string;
    key?: string;
    maskedKey?: string;
    isEnabled?: boolean;
    alreadyExists?: boolean;
    groupCalculatedCount?: number;
    mskRiskCalculatedCount?: number;
    mskHealthCalculatedCount?: number;
}

interface GenerateKeyBody {
    orgName: string;
    paymentCycle?: NumericListOptions | null;
    billingStartDate?: string | null;
}

interface SetKeyStatusBody {
    isEnabled: boolean;
    paymentCycle?: NumericListOptions | null;
    billingStartDate?: string | null;
}

const ExternalOrgService = {
    generateKey: (orgId: string, orgName: string, paymentCycle?: NumericListOptions, billingStartDate?: string) =>
        ServiceBase.post<ApiKeyResponse, GenerateKeyBody>(`/admin/organizations/${orgId}/external-api-key`)({
            orgName,
            paymentCycle: paymentCycle ?? null,
            billingStartDate: billingStartDate ?? null,
        }),

    getKey: (orgId: string) =>
        ServiceBase.get<ApiKeyResponse | null>(`/admin/organizations/${orgId}/external-api-key`)(),

    rotateKey: (orgId: string) =>
        ServiceBase.post<ApiKeyResponse, void>(`/admin/organizations/${orgId}/external-api-key/rotate`)(),

    revealKey: (orgId: string) =>
        ServiceBase.get<{ key: string }>(`/admin/organizations/${orgId}/external-api-key/reveal`)(),

    setKeyStatus: (orgId: string, isEnabled: boolean, paymentCycle?: NumericListOptions, billingStartDate?: string) =>
        ServiceBase.post<{ isEnabled: boolean }, SetKeyStatusBody>(`/admin/organizations/${orgId}/external-api-key/status`)({
            isEnabled,
            paymentCycle: paymentCycle ?? null,
            billingStartDate: billingStartDate ?? null,
        }),
};

export default ExternalOrgService;
